import { oldApiInstance } from 'functions/request';

export const fetchPromoSearchTagsApi = ({ search, page, perPage }) => {
  return oldApiInstance.get(`shop/on_sale_items?search=${search}&page=${page}&per_page=${perPage}`);
};
